import './footer.css'
import versionInfo from '../../version.json'
import logoDeltabyte from '../img/logo-deltabyte.png'

function Footer() {

    return(
        <footer className="footer-box">
            <a
                className="footer-logo-link"
                href="https://deltabyte.com.br"
                target="_blank"
                rel="noopener noreferrer"
                title="Conheça a Deltabyte"
            >
                <img className="footer-logo" src={logoDeltabyte} alt="Deltabyte" />
            </a>
            <div className='footer-box-version'>Copyright &#9400; 2024 - Deltabyte - v{versionInfo.version}</div>
        </footer>

    )
}

export default Footer
